module.exports = __webpack_public_path__ + "static/media/69.338423a3.jpg";